export default "__VITE_ASSET__5HZk$WKP__"